import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useIndustries() {
  const [loading, setLoading] = useState(true);
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.industries.index)
      .then((response) => {
        setIndustries(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, industries };
}
